<app-header></app-header>
<app-home></app-home>
<app-main></app-main>
<app-footer></app-footer>
